<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="form" :model="form" label-width="150px" :inline="true">
        <el-form-item label="分润企业名称">
          <el-input
            v-model="form.accountAlias"
            placeholder="请输入分润企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            v-model="form.orderNo"
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="商户号">
          <el-input
            v-model="form.merchantId"
            placeholder="请输入商户号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="客户电话">
          <el-input
            v-model="form.phone"
            placeholder="请输入客户电话"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属企业">
          <el-select
            multiple
            v-model="form.companyId"
            placeholder="全部"
            clearable
            filterable
          >
            <el-option
              v-for="(v, i) in pullListArr"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="form.regionId"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select
            v-model="form.orderType"
            placeholder="全部"
            clearable
            filterable
          >
            <el-option label="消费订单" value="1"></el-option>
            <el-option label="充值订单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = {
                startTime: '',
                endTime: '',
                companyId: [],
                regionId: [],
              };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="flex mgt-20">
      <div class="flex fw-600  color052154 mgr-200">
        <span class="mgr-20">订单金额：{{ orderPrice }}</span>
        <span class="mgr-20">订单实付金额：{{ payPrice }}</span>
        <span class="mgr-20">分润金额：{{ sharePrice }}</span>
      </div>
    </div>
    <div class="flex jcsb">
      <!-- <el-button v-if="roleId !== 23" class="mgt-20" @click="goafterOrder"
            >售后订单</el-button
          > -->
      <btns @exec="exec"></btns>
    </div>
    <!-- 表格 -->
    <el-table
      class="mgt-15"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="accountAlias" label="分润企业名称">
      </el-table-column>
      <!-- <el-table-column prop="customerName" label="所属企业"> </el-table-column> -->
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <el-table-column prop="phone" label="客户手机号"> </el-table-column>
      <el-table-column prop="merchantId" label="商户号"> </el-table-column>
      <el-table-column prop="orderNo" label="订单号"> </el-table-column>
      <el-table-column prop="orderPrice" label="订单金额"> </el-table-column>
      <el-table-column prop="payPrice" label="订单实际支付金额">
      </el-table-column>
      <el-table-column prop="sharePrice" label="分润金额"> </el-table-column>
      <el-table-column prop="shareProportion" label="分润比例（%）">
      </el-table-column>
      <el-table-column prop="orderPrice" label="订单类型">
        <template slot-scope="scope">
          <span
            v-text="scope.row.orderType == 1 ? '消费订单' : '充值订单'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      top="40vh"
    >
      <div class="mgb-10">温馨提示:不填写条件则导出全部</div>
      <el-form
        ref="exportForm"
        :model="exportForm"
        label-width="100px"
        :inline="true"
      >
        <el-form-item label="分润企业名称">
          <el-input
            v-model="exportForm.accountAlias"
            placeholder="请输入分润企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            v-model="exportForm.orderNo"
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="商户号">
          <el-input
            v-model="exportForm.merchantId"
            placeholder="请输入商户号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="客户电话">
          <el-input
            v-model="exportForm.phone"
            placeholder="请输入客户电话"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属企业">
          <el-select
            multiple
            v-model="exportForm.qiye"
            placeholder="全部"
            clearable
            filterable
          >
            <el-option
              v-for="(v, i) in pullListArr"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属分区">
          <el-select
            multiple
            filterable
            v-model="exportForm.regionId"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select
            v-model="exportForm.orderType"
            placeholder="全部"
            clearable
            filterable
          >
            <el-option label="消费订单" value="1"></el-option>
            <el-option label="充值订单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="exportForm.startTime"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="exportForm.endTime"
            :picker-options="pickerOptionsEnd1"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportBtnSure('exportForm')"
          >导 出</el-button
        >
      </span>
    </el-dialog>

    <!-- 导出选择数据弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportChangeNumVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      top="30vh"
    >
      <el-descriptions column="5" border title="请选择需要导出的数据">
        <el-descriptions-item v-for="(v, i) in radioArr" :key="i" label="范围">
          <el-radio v-model="radio" :label="v.id" @input="changeRadioInput">{{
            v.start + "-" + v.end + "条"
          }}</el-radio></el-descriptions-item
        >
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportChangeNumVisible = false"
          >关 闭</el-button
        >
        <el-button type="primary" @click="exportNumBtn">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsEnd1: {
        disabledDate: (time) => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {
        companyId: [],
        regionId: [],
      },
      zoneArr: [],
      pullListArr: [],
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数

      orderPrice: 0,
      payPrice: 0,
      sharePrice: 0,
      exportVisible: false,
      exportForm: {
        accountAlias: "",
        orderNo: "",
        merchantId: "",
        phone: "",
        qiye: [],
        regionId: [],
        orderType: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 500000,
      },
      interval: 2000,
      radioArr: [],

      exportChangeNumVisible: false,
      radio: "1",
    };
  },
  created() {
    // this.getPullList();
    this.getZone();
    this.getList();

    this.getStatistics();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.enterpriseincome
        .kfDetail({ pageNum: this.page, pageSize: this.pageSize, ...this.form })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
      this.getStatistics();
    },
    getStatistics() {
      this.$api.enterpriseincome
        .allStic({
          // companyId:
          ...this.form
        })
        .then((res) => {
          if (res.code === 200) {
            console.log("查看这个分账记录统计", res);
            this.orderPrice = res.data.orderPrice;
            this.payPrice = res.data.payPrice;
            this.sharePrice = res.data.sharePrice;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },

    // 企业列表下拉
    // getPullList() {
    //   this.$api.enterprise.enterpriseListPullNew().then((res) => {
    //     this.pullListArr = res.data;
    //   });
    // },
    getZone() {
      //   this.$api.order.allZonePull().then((res) => {
      //     if (res.code === 200) {
      //       this.zoneArr = res.data;
      //     }
      //   });
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    exec(fun) {
      console.log("？？？？？？？？？？？", fun);
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    export() {
      this.exportForm = {
        qiye: [],
        startTime: "",
        endTime: "",
      };
      this.exportVisible = true;
    },
    exportBtnSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.enterpriseincome
            .ExportShareNum({
              accountAlias: this.exportForm.accountAlias,

              orderNo: this.exportForm.orderNo,
              merchantId: this.exportForm.merchantId,
              phone: this.exportForm.phone,
              companyId: this.exportForm.qiye,

              regionId: this.exportForm.regionId,
              orderType: this.exportForm.orderType,
              startTime: this.exportForm.startTime,
              endTime: this.exportForm.endTime,
              type: 0,
              pageNum: this.exportForm.pageNum,
              pageSize: this.exportForm.pageSize,
            })
            .then((a) => {
              console.log("查看导出确定", a);

              if (a.code === 200) {
                if (Number(a.data) > this.interval) {
                  this.radioArr = []; // 清空之前的范围
                  let id = 1; // 从1开始递增的ID
                  for (let i = 0; i < a.data; i += this.interval) {
                    const end = Math.min(i + this.interval - 1, a.data - 1);
                    this.radioArr.push({ id, start: i + 1, end: end + 1 });
                    id++;
                  }
                  this.exportVisible = false;
                  this.radio = "";
                  this.exportChangeNumVisible = true;
                  console.log("查看 radioArr", this.radioArr);
                } else {
                  handleConfirm("确认导出吗?", "info")
                    .then(() => {
                      this.$api.enterpriseincome
                        .ExportShareNumDownload({
                          accountAlias: this.exportForm.accountAlias,

                          orderNo: this.exportForm.orderNo,
                          merchantId: this.exportForm.merchantId,
                          phone: this.exportForm.phone,
                          companyId: this.exportForm.qiye,

                          regionId: this.exportForm.regionId,
                          orderType: this.exportForm.orderType,
                          startTime: this.exportForm.startTime,
                          endTime: this.exportForm.endTime,
                          type: 1,
                          pageNum: 1,
                          pageSize: 50000,
                          limitStart: 1,
                          limitEnd: a.data,
                        })
                        .then((res) => {
                          console.log("确认导出", res);
                          this.exportVisible = false;
                          const link = document.createElement("a");
                          link.style.display = "none";
                          link.href = URL.createObjectURL(res);
                          link.setAttribute("download", "空分明细.xls");
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          handleAlert("导出成功", "success");
                        });
                    })
                    .catch(() => {
                      return;
                    });
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    exportNumBtn() {
      if (!this.radio) {
        handleAlert("请选择条数范围", "error");
        return;
      }
      this.radioArr.forEach((v) => {
        if (this.radio == v.id) {
          this.exportForm.limitStart = v.start;
          this.exportForm.limitEnd = v.end;
        }
      });

      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.enterpriseincome
            .ExportShareNumDownload({
              accountAlias: this.exportForm.accountAlias,

              orderNo: this.exportForm.orderNo,
              merchantId: this.exportForm.merchantId,
              phone: this.exportForm.phone,
              companyId: this.exportForm.qiye,

              regionId: this.exportForm.regionId,
              orderType: this.exportForm.orderType,
              startTime: this.exportForm.startTime,
              endTime: this.exportForm.endTime,
              type: 1,
              pageNum: this.exportForm.pageNum,
              pageSize: this.exportForm.pageSize,
              limitStart: this.exportForm.limitStart,
              limitEnd: this.exportForm.limitEnd,
            })
            .then((res) => {
              handleAlert("导出成功", "success");
              this.exportChangeNumVisible = false;
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute(
                "download",
                `空分明细(${this.exportForm.limitStart}-${this.exportForm.limitEnd}).xls`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        })
        .catch(() => {
          return;
        });
    },
    changeRadioInput(val) {
      console.log("?????", val);
    },
  },
};
</script>

<style lang="scss" scoped></style>
